/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Select_Preset_TextInputs */



/**
* | output |
* | --- |
* | "Select a preset to view details" |
*
* @param {Preset_Manager_Select_Preset_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_select_preset_text = /** @type {((inputs?: Preset_Manager_Select_Preset_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Select_Preset_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un preset pour voir les details")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Voreinstellung aus, um Details anzuzeigen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un preset per visualizzare i dettagli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предустановку, чтобы просмотреть подробности.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un ajuste preestablecido para ver los detalles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择预设以查看详情")
	if (locale === "ja") return /** @type {LocalizedString} */ ("詳細を表示するにはプリセットを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विवरण देखने के लिए एक प्रीसेट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma predefinição para ver os detalhes.")
	return /** @type {LocalizedString} */ ("Select a preset to view details")
});